// export const Url = "https://devapi.titegypt.org";
export const Url = "https://apibe.nilecapitalcruises.com";
